import { Component, Input } from '@angular/core';

/**
 * Responsive chart grid that avoids empty columns when item count < max columns.
 * `count` is the number of chart tags projected into this grid (caller-supplied,
 * since Angular content projection doesn't expose child count declaratively).
 */
@Component({
  selector: 'app-br-chart-grid',
  templateUrl: './chart-grid.component.html'
})
export class BrChartGridComponent {
  @Input() variant: 'kpi' | 'detail' = 'detail';
  @Input() count: number;
}
